import { Button, Typography } from '@mui/material'
import { find } from 'lodash'
import { FC } from 'react'
import DropdownArrowIcon from '../../../../assets/icons/DropdownArrow.svg?react'
import { useWrapperStore } from '../../../../store/storeWrapper'
import { AgentOrAssistantSelect } from '../../MainPage/components/AgentOrAssistantSelect'

export const ModelSelect: FC = () => {
    const {
        setNameOpenDialog,
        currentAssistantIdDialog,
        modelListActive,
        currentAgentNameInDialog,
        currentAssistantDataInDialog,
    } = useWrapperStore((state) => state)

    const handleClick = () => {
        setNameOpenDialog('AssistantSelectionDialog')
    }

    const isAssistantActive = currentAssistantIdDialog !== 'null' && !!currentAssistantIdDialog
    const label = isAssistantActive
        ? currentAssistantDataInDialog?.name
        : find(modelListActive, { slug: currentAgentNameInDialog })?.title

    return (
        <>
            <Button
                variant="outlined"
                onClick={handleClick}
                endIcon={<DropdownArrowIcon color="#5A5F72" />}
                sx={{
                    width: '100%',
                    justifyContent: 'space-between',
                    ':hover': {
                        backgroundColor: 'transparent',
                    },
                }}>
                <Typography variant="body2">{label}</Typography>
            </Button>
            <AgentOrAssistantSelect hideButton />
        </>
    )
}
